import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../model/RootStoreContext';
import { IEntityVersion } from '../model/entity/EntityVersion';
import { IKindVersion } from '../model/kind/KindVersion';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useEntityVersionWithKindVersionResult {
    isLoaded: boolean;
    kindVersion: IKindVersion | null;
}

export const useKindVersionForEntityVersion = (entityVersion: IEntityVersion | null) => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState<useEntityVersionWithKindVersionResult>(() => ({
        isLoaded: false,
        kindVersion: null
    }));

    useEffect(() => {
        setResult({ isLoaded: false, kindVersion: null });

        if (entityVersion != null) {
            rootStore.kindVersionStore.loadVersionForCurrentKind(entityVersion.kindVersionSummary.version)
                .then(kindVersion => {
                    setResult({ isLoaded: true, kindVersion: kindVersion });
                })

                .catch(e => {
                    setResult({ isLoaded: true, kindVersion: null });
                    publishNotification({
                        text: 'Error loading kind version'
                    });
                });
        } else
            setResult({ isLoaded: true, kindVersion: null });


    }, [rootStore.kindVersionStore, publishNotification, entityVersion, entityVersion?.kindVersionSummary]);

    return result;
};
